import React, { useState } from "react";
import { Image, StyleSheet, View } from "react-native";
import * as Yup from "yup";

import authApi from "../api/auth";
import Screen from "../components/Screen";
import colors from "../config/colors";
import {
  AppForm,
  AppFormField,
  ErrorMessage,
  SubmitButton,
} from "../components/forms";
import AppButton from "../components/AppButton";
import routes from "../navigation/routes";
import useAuth from "../auth/useAuth";
import useApi from "../hooks/useApi";
import ActivityIndicator from "../components/ActivityIndicator";
import AppText from "../components/AppText";

const validationSchema = Yup.object().shape({
  email: Yup.string().required().email().label("Email"),
});

function ForgotPasswordScreen({ navigation, route }) {
  const loginApi = useApi(authApi.forgot);
  const [submitError, setSubmitError] = useState();

  const handleSubmit = async ({ email }) => {
    const result = await loginApi.request(email);
    console.log(result.data, "kfjd");

    if (result.data.response.message === "success") {
      setSubmitError("");
      navigation.navigate("OTP", email);
    } else {
      setSubmitError(result.data.response.message);
    }
  };

  return (
    <Screen style={styles.container}>
      <Image
        source={require("../assets/paris_portrait.jpg")}
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          // resizeMode: "contain",
        }}
      />

      <ActivityIndicator visible={loginApi.loading} />
      <View style={styles.logo}>
        <AppText
          color="transparent"
          textColor="white"
          style={{
            paddingHorizontal: 20,
            alignSelf: "center",
            // position: 'absolute',
            // top: 20,
            marginBottom: 20,
            fontSize: 20,
            fontWeight: "bold",
          }}
        >
          Forgot Password
        </AppText>
        <AppForm
          initialValues={{ email: "" }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {/* <ErrorMessage
            error="Invalid email/username or password."
            visible={submitError}
            login={true}
          /> */}
          <AppFormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="email"
            keyboardType="email-address"
            name="email"
            placeholder="Email"
            textContentType="emailAddress"
            login={true}
          />
          <ErrorMessage
            error={submitError}
            visible={submitError}
            login={true}
          />
          <SubmitButton style={styles.submitButton} title="Submit" />
        </AppForm>
      </View>
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    // padding: 10,
  },
  logo: {
    backgroundColor: colors.skyBlueTrans,
    // width: '100%',
    // height: '100%',
    flex: 1,
    paddingHorizontal: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  submitButton: {
    marginTop: 20,
  },
});

export default ForgotPasswordScreen;
